import React, { useContext } from "react";

import { Modal } from "react-bootstrap";
import { Form, Input, Button, Radio, Space } from "antd";
import { useMutation } from "react-query";
import { MinusCircleOutlined } from "@ant-design/icons";

import "../../../assets/css/dashboard.css";
import { ModalContext } from "context/ModalContext";
import { addSchemeGroup } from "services/apiSrv";
import { show_toast } from "utils/helpers";

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const AddSchemeGroup = (props) => {
  const { TextArea } = Input;
  const { modalClose } = useContext(ModalContext);

  const add_group = useMutation(addSchemeGroup, {
    onSuccess: (data) => {
      modalClose();
      props.refetch();
      show_toast("Group added successfully", "success");
    },
    onError: async (error) => {
      let err = await error;
      modalClose();
      console.log("error adding group", err);
    },
  });

  const onFinish = (values) => {
    let val = {};
    val = { ...values, scheme_id: props.scheme_id };
    console.log("Success:", val);
    add_group.mutate(val);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey text-center">Add Scheme Group</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            name="add_scheme_document"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
            validateMessages={validateMessages}
            layout="vertical"
            initialValues={{ scheme_group_detail: "" }}
          >
            <Form.Item
              label="Group Name"
              name="scheme_group_name"
              labelAlign="left"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="scheme_group_type"
              label="Group Type"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio value="voluntary">Voluntary</Radio>
                <Radio value="mandatory">Mandatory</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="policy_management_type"
              label="Policy Management Type"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio value="individual">Individual</Radio>
                <Radio value="group">Group</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="Other Details">
              <Form.List name="scheme_group_detail">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field) => (
                      <Space
                        key={field.key}
                        align="baseline"
                        style={{ width: "100%" }}
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "key"]}
                          fieldKey={[field.fieldKey, "key"]}
                          rules={[
                            {
                              required: true,
                              message: "Key is required",
                            },
                          ]}
                        >
                          <Input placeholder="Detail Name" />
                        </Form.Item>

                        <Form.Item
                          {...field}
                          name={[field.name, "value"]}
                          fieldKey={[field.fieldKey, "value"]}
                          rules={[
                            {
                              required: true,
                              message: "Value is required",
                            },
                          ]}
                        >
                          <Input placeholder="Detail Value" />
                        </Form.Item>

                        <MinusCircleOutlined
                          onClick={() => remove(field.name)}
                        />
                      </Space>
                    ))}

                    <Form.Item>
                      <Button type="dashed" onClick={() => add()} block>
                        Add Detail
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
            <Form.Item
              label="Description"
              name="scheme_group_description"
              labelAlign="left"
              rules={[{ required: true }]}
            >
              <TextArea rows={4} />
            </Form.Item>
            <Form.Item>
              <Button
                className="btn-blue text-white float-right mb-5  px-4 py-1 rounded "
                htmlType="submit"
                disabled={add_group.isLoading}
              >
                {add_group.isLoading ? (
                  <div className="text-white">
                    <i
                      className="fa fa-circle-notch fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                    Loading..
                  </div>
                ) : (
                  "Add Group"
                )}
              </Button>
            </Form.Item>
          </Form>

          {/* <SchemeGroupForm /> */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddSchemeGroup;
